import { LazyLoad } from 'app/utils';

export const AdminFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.AdminFormPage,
);
